import { EulerStateManager } from "../EulerStateManager";
import { BaseState } from "../States/BaseState";
import { EventData } from "../EventData";

class EventEnd extends BaseState<EulerStateManager> {
  public id = "EventEnd"; // A unique identifier for the state
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterEventEndState();
    this.endCurrentEvent();
  }

  private endCurrentEvent() {
    const eventData = EventData.getInstance();
    //eventData.closeGamesocket();
    window.location.reload();
    //this.transition();
  }

  private transition() {
    this.stateManager!.changeState(this.stateManager!.eulerGetNextEventState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { EventEnd };
